// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAI8MEg9o4ef363ezHnYSrG8tzTdDIq1yc",
    authDomain: "trascat-aef74.firebaseapp.com",
    databaseURL: "https://trascat-aef74.firebaseio.com",
    projectId: "trascat-aef74",
    storageBucket: "trascat-aef74.appspot.com",
    messagingSenderId: "861934696571"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
